import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";
import { Form, Input, Button, Select, Card, List, Typography } from "antd";
import { toast, ToastContainer } from "react-toastify";

export default function AddDepartments() {
    const { backUrl, authData } = useContext(AuthContext);
    const { Option } = Select;
    const { Title } = Typography;

    const [departments, setDepartments] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [selectedOrg, setSelectedOrg] = useState(null);

    const [newDept, setNewDept] = useState({
        name: "",
        organisation: ""
    });

    const [loading, setLoading] = useState(false);

    // ✅ Fetch Organizations
    const fetchOrganizations = async () => {
        try {
            const res = await axios.get(`${backUrl}/api/emp/organisations/`);
            setOrganizations(res.data.results);
        } catch (err) {
            console.error("Error fetching organizations", err);
        }
    };

    // ✅ Fetch Departments (based on organization)
    const fetchDepartments = async (orgId) => {
        try {
            const res = await axios.get(
                `${backUrl}/api/emp/departments/?organisation=${orgId}`
            );
            setDepartments(res.data.results);
        } catch (err) {
            console.error("Error fetching departments", err);
        }
    };

    // ✅ Add Department
    const handleAddDepartment = async () => {
        if (!newDept.name || !newDept.organisation) {
            toast.error("All fields are required");
            return;
        }

        try {
            setLoading(true);

            await axios.post(
                `${backUrl}/api/emp/departments/`,
                newDept,
                {
                    headers: {
                        Authorization: `Bearer ${authData?.access}`,
                    },
                }
            );

            toast.success("Department added successfully!");

            setNewDept({ name: "", organisation: selectedOrg });

            // Refresh list
            fetchDepartments(selectedOrg);
        } catch (err) {
            console.error("Error adding department", err);
            toast.error("Failed to add department");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchOrganizations();
    }, []);

    return (
        <center>
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
                draggable
            />
            <div style={{ padding: "20px", width: '600px' }}>
                <Title level={4}>Add Departments</Title>

                {/* 🔹 Select Organization */}
                <Card style={{ marginBottom: "20px" }}>
                    <Select
                        placeholder="Select Organization"
                        style={{ width: "100%" }}
                        onChange={(value) => {
                            setSelectedOrg(value);
                            setNewDept({ ...newDept, organisation: value });
                            fetchDepartments(value);
                        }}
                    >
                        {organizations.map((org) => (
                            <Option key={org.id} value={org.id}>
                                {org.name}
                            </Option>
                        ))}
                    </Select>
                </Card>

                {/* 🔹 Add Department */}
                <Card title="Add Department" style={{ marginBottom: "20px" }}>
                    <Form layout="vertical">
                        <Form.Item label="Department Name">
                            <Input
                                placeholder="Enter department name"
                                value={newDept.name}
                                onChange={(e) =>
                                    setNewDept({ ...newDept, name: e.target.value })
                                }
                            />
                        </Form.Item>

                        <Button
                            type="primary"
                            onClick={handleAddDepartment}
                            loading={loading}
                            disabled={!selectedOrg}
                            style={{ backgroundColor: '#0e497b', color: 'white' }}
                            block
                        >
                            Add Department
                        </Button>
                    </Form>
                </Card>

                {/* 🔹 List Departments */}
                {/* <Card title="Departments List">
                <List
                    bordered
                    dataSource={departments}
                    renderItem={(item) => (
                        <List.Item>
                            {item.name}
                        </List.Item>
                    )}
                    locale={{ emptyText: "No departments found" }}
                />
            </Card> */}
            </div>
        </center>
    );
}